import { createTheme } from '@mui/material';
import styles from '../stylesheets/variables.scss';
import { convertBreakpoint } from '../utils/usefulFunctions';

const defaultTheme = {
    breakpoints: {
        values: {
            xs: 0,
            sm: convertBreakpoint(styles.sm),
            md: convertBreakpoint(styles.md),
            lg: convertBreakpoint(styles.lg),
            xl: convertBreakpoint(styles.xl),
            xxl: convertBreakpoint(styles.xxl),
            xxxl: convertBreakpoint(styles.xxxl),
        },
    },
    palette: {
        primary: {
            light: styles.primary200,
            main: styles.primary400,
            dark: styles.primary700,
        },
        secondary: {
            light: styles.grey200,
            main: styles.grey600,
            dark: styles.grey700,
        },
        error: {
            light: styles.error200,
            main: styles.error400,
            dark: styles.error700,
        },
        // styles.grey100,
        // styles.grey200,
        // styles.grey600,
        // styles.grey700,
        // styles.grey900,
    },
    typography: {
        fontFamily: `'Montserrat', sans-serif`,
        h1: {
            fontSize: 24,
            fontWeight: 600,
        },
        h2: {
            fontSize: 20,
            fontWeight: 600,
        },
        h3: {
            fontSize: 14,
            fontWeight: 600,
        },
        button: {
            fontFamily: `'Montserrat', sans-serif`,
            fontWeight: 600,
            textTransform: 'none',
            lineHeight: 1.5,
        },
        body1: {
            fontSize: 14,
            fontFamily: `'Montserrat', sans-serif`,
        },
        body2: {
            fontSize: 14,
            fontWeight: 600,
            fontFamily: `'Montserrat', sans-serif`,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    '&::first-letter': {
                        textTransform: 'uppercase',
                    },
                    ':hover': {
                        color: styles.primary700,
                        // outline: `1px solid ${primary700}`,
                    },
                },
                text: {
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.02) !important',
                        color: styles.primary700,
                    },
                },
                contained: {
                    '&:hover': {
                        color: styles.white,
                    },
                    '&.Mui-disabled': {
                        backgroundColor: styles.disabledButton,
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    overflow: 'unset',
                    borderRadius: '5px',
                    boxShadow: `unset`,
                    transition: 'inset',
                    border: `1px solid ${styles.grey200}`,
                    backgroundColor: styles.white,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontFamily: `'Montserrat', sans-serif !important`,
                    fontWeight: 400,
                },
                stickyHeader: {
                    fontFamily: `'Montserrat', sans-serif !important`,
                    backgroundColor: 'white',
                    fontWeight: 500,
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    height: 7,
                    borderRadius: 5,
                    backgroundColor: styles.background,
                },
                bar: {
                    borderRadius: 5,
                    backgroundColor: styles.primaryBrigth,
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    '&.MuiStepLabel-alternativeLabel': {
                        marginTop: '8px',
                    },
                },
            },
        },
        MuiStepConnector: {
            styleOverrides: {
                root: {
                    top: '6px',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                standardInfo: {
                    backgroundColor: '#f5f6fa',
                    color: '#004c70',
                    '& .MuiAlert-icon': {
                        color: '#004c70',
                    },
                },
            },
        },
    },
};

export default createTheme(defaultTheme);
